module.exports = __webpack_public_path__ + "img/高效组件 通威智造.37ea0c4b.png";